import * as $ from 'jquery';
import 'slick-carousel/slick/slick.min.js';

export default class SliderController {
  private readonly slickGallery3SlidesSelector = '.js-slick-gallery--3slides';
  private readonly slickGalleryGallerySelector = '.js-slick-gallery--gallery';
  private readonly slickGalleryGalleryThumbSelector = '.js-slick-gallery__thumb--gallery';
  private readonly slickTestTrackSelector = '.js-testtrackSlider';
  private $slickGallery3Slides = $(this.slickGallery3SlidesSelector);
  private $slickGalleryGallery = $(this.slickGalleryGallerySelector);
  private $slickTestTrack = $(this.slickTestTrackSelector);
  private maxVisibleTestTrackElements = 4;

  constructor() {
    this.initGallerySlider();
    this.initGallery3SlidesSlider();
    this.initSlickSliders();
  }

  initGallerySlider() {
    this.$slickGalleryGallery.each((index, element) => {

      $(element).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        variableWidth: false,
        adaptiveHeight: true,
      });

      $(element).parent().find(this.slickGalleryGalleryThumbSelector).slick({
        arrows: false,
        slidesToScroll: 1,
        slidesToShow: 10,
        asNavFor: $(element),
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        adaptiveHeight: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 6,
            },
          },
        ],
      });
      $(element).on(
        'beforeChange',
        (event, slick, slide, nextSlide) => {
          slick.$slider.parent().find(this.slickGalleryGalleryThumbSelector + ' .slick-slide')
            .removeClass('slick-current').eq(nextSlide).addClass('slick-current');
        },
      );
    });
  }

  initGallery3SlidesSlider() {
    let setGallerySlideSiblings = function ($currentSlide, nextSlide) {
      $currentSlide.find('.slick-slide').removeClass('slick-sibling');
      let $nextSlideElement = this.$slickGallery3Slides.find('[data-slick-index=\'' + nextSlide + '\']');
      $nextSlideElement.next().addClass('slick-sibling');
      $nextSlideElement.prev().addClass('slick-sibling');
    }.bind(this);

    let addGalleryImageClickWatcher = function () {
      this.$slickGallery3Slides.find('.js-galleryImage').on('click', function (event) {
        let $wrapper = $(event.target).closest(this.$slickGallery3Slides);
        $wrapper.slick('slickGoTo', $(event.target).closest('.slick-slide').data('slick-index'));
      }.bind(this));
    }.bind(this);

    this.$slickGallery3Slides.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      setGallerySlideSiblings($(this), nextSlide);
    });
    this.$slickGallery3Slides.on('init', function () {
      setGallerySlideSiblings($(this), 0);
      addGalleryImageClickWatcher();
    });

    if (this.$slickGallery3Slides.children().length <= 3) {
      this.$slickGallery3Slides.addClass('gallerySlider--threeOrLess');
    }

    this.$slickGallery3Slides.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        centerMode: true,
        swipe: false,
        draggable: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 1,
              swipe: true,
              draggable: true,
            },
          },
        ],
      },
    );

    this.$slickGallery3Slides.on('breakpoint', function () {
      setGallerySlideSiblings($(this), 0);
      addGalleryImageClickWatcher();
    });
  }

  initSlickSliders() {
    this.$slickTestTrack.each((testtrackIndex, testtrackSlider) => {
      const $testtrackSlider = $(testtrackSlider);
      const slidesCount = $testtrackSlider.find('.testtrackSlider__item ').length;

      let resetSlideIndex = (nextSlide) => {
        let $slideElements = $testtrackSlider.find('.slick-slide');
        let query = 'testtrackSlider__item--left testtrackSlider__item--0';

        // remove all classes for height reset
        for (let i = 1; i <= this.maxVisibleTestTrackElements; i++) {
          $slideElements.removeClass('testtrackSlider__item--' + i);
          query += ' testtrackSlider__item--' + i;

        }
        $slideElements.removeClass(query);

        let $nextSlideElement = $testtrackSlider.find('[data-slick-index=\'' + nextSlide + '\']');
        $nextSlideElement.addClass('testtrackSlider__item--0');
        setSlideIndexRecursive($nextSlideElement, true, 1);
        setSlideIndexRecursive($nextSlideElement, false, 1);
      };

      let setSlideIndexRecursive = (element, forwards, index) => {
        if (element) {
          let $next;
          if (forwards) {
            $next = $(element).next();
          } else {
            $next = $(element).prev();
          }
          if ($next.length > 0) {
            let newIndex = (index < this.maxVisibleTestTrackElements) ? index : this.maxVisibleTestTrackElements;
            $next.addClass('testtrackSlider__item--' + newIndex);
            if (!forwards) {
              $next.addClass('testtrackSlider__item--left');
            }
            setSlideIndexRecursive($next, forwards, index + 1);
          }
        }
      };

      $testtrackSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        resetSlideIndex(nextSlide);
      });

      $testtrackSlider.on('init', () => {
        let $currentSlideElement = $testtrackSlider.find('.slick-current');
        $currentSlideElement.addClass('testtrackSlider__item--0');
        setSlideIndexRecursive($currentSlideElement, true, 1);
        setSlideIndexRecursive($currentSlideElement, false, 1);
      });

      $testtrackSlider.slick({
        slidesToShow: slidesCount <= 5 ? 3 : 5,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        centerMode: true,
        swipe: true,
        focusOnSelect: true,
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              centerMode: true,
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: true,
              slidesToShow: 1,
            },
          },
        ],
      });
    });
  }
}

export function refreshAllSliders(wrapperElement) {
  $(wrapperElement).find('.js-testtrackSlider, .js-slick-gallery--gallery, .js-slick-gallery--3slides, .js-slick-gallery__thumb--gallery').slick('refresh');
}
